export default "__VITE_ASSET__C8S_$9Pk__"